module.exports = __webpack_public_path__ + "media/images/common/logo-ba05eb8589aa995053123a9ab9f079e9.png";